/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetRegisterDto } from './GetRegisterDto';
import {
    GetRegisterDtoFromJSON,
    GetRegisterDtoFromJSONTyped,
    GetRegisterDtoToJSON,
} from './GetRegisterDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetExamDto } from './GetExamDto';
import {
    GetExamDtoFromJSON,
    GetExamDtoFromJSONTyped,
    GetExamDtoToJSON,
} from './GetExamDto';
import type { GetCardDto } from './GetCardDto';
import {
    GetCardDtoFromJSON,
    GetCardDtoFromJSONTyped,
    GetCardDtoToJSON,
} from './GetCardDto';
import type { GetArticleDto } from './GetArticleDto';
import {
    GetArticleDtoFromJSON,
    GetArticleDtoFromJSONTyped,
    GetArticleDtoToJSON,
} from './GetArticleDto';

/**
 * 
 * @export
 * @interface GetJudgmentDto
 */
export interface GetJudgmentDto {
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetJudgmentDto
     */
    lp?: number | null;
    /**
     * 
     * @type {GetExamDto}
     * @memberof GetJudgmentDto
     */
    exam?: GetExamDto | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentDto
     */
    nextExamDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentDto
     */
    judgmentDate?: Date | null;
    /**
     * 
     * @type {GetArticleDto}
     * @memberof GetJudgmentDto
     */
    article?: GetArticleDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetJudgmentDto
     */
    psychologist?: GetUserDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    pass?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    occupationalMedicineOneCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    occupationalMedicineText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    vehicleRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    personRestriction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    drivingLicense?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    roadTransport?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    active?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    withoutSign?: boolean | null;
    /**
     * 
     * @type {GetRegisterDto}
     * @memberof GetJudgmentDto
     */
    register?: GetRegisterDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    twilightVision?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    glareSensitivity?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    comment?: string | null;
    /**
     * 
     * @type {GetCardDto}
     * @memberof GetJudgmentDto
     */
    card?: GetCardDto | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    art39j?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    contactWithFood?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentDto
     */
    dateFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetJudgmentDto
     */
    dateTo?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJudgmentDto
     */
    requiresCorrectiveEyewear?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentDto
     */
    statusP1: GetJudgmentDtoStatusP1Enum | null;
    /**
     * Status of the judgment cancellation document in P1, if any
     * @type {string}
     * @memberof GetJudgmentDto
     */
    cancelStatusP1: GetJudgmentDtoCancelStatusP1Enum | null;
    /**
     * Reason given for the judgment cancellation in P1, if any
     * @type {string}
     * @memberof GetJudgmentDto
     */
    cancellationReason: string | null;
}


/**
 * @export
 */
export const GetJudgmentDtoStatusP1Enum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type GetJudgmentDtoStatusP1Enum = typeof GetJudgmentDtoStatusP1Enum[keyof typeof GetJudgmentDtoStatusP1Enum];

/**
 * @export
 */
export const GetJudgmentDtoCancelStatusP1Enum = {
    ToSign: 'ToSign',
    WaitingForP1: 'WaitingForP1',
    AcceptedInP1: 'AcceptedInP1',
    RejectedInP1: 'RejectedInP1',
    ValidationFailed: 'ValidationFailed'
} as const;
export type GetJudgmentDtoCancelStatusP1Enum = typeof GetJudgmentDtoCancelStatusP1Enum[keyof typeof GetJudgmentDtoCancelStatusP1Enum];


/**
 * Check if a given object implements the GetJudgmentDto interface.
 */
export function instanceOfGetJudgmentDto(value: object): value is GetJudgmentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('statusP1' in value) || value['statusP1'] === undefined) return false;
    if (!('cancelStatusP1' in value) || value['cancelStatusP1'] === undefined) return false;
    if (!('cancellationReason' in value) || value['cancellationReason'] === undefined) return false;
    return true;
}

export function GetJudgmentDtoFromJSON(json: any): GetJudgmentDto {
    return GetJudgmentDtoFromJSONTyped(json, false);
}

export function GetJudgmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJudgmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'lp': json['lp'] == null ? undefined : json['lp'],
        'exam': json['exam'] == null ? undefined : GetExamDtoFromJSON(json['exam']),
        'nextExamDate': json['nextExamDate'] == null ? undefined : (new Date(json['nextExamDate'])),
        'judgmentDate': json['judgmentDate'] == null ? undefined : (new Date(json['judgmentDate'])),
        'article': json['article'] == null ? undefined : GetArticleDtoFromJSON(json['article']),
        'psychologist': json['psychologist'] == null ? undefined : GetUserDtoFromJSON(json['psychologist']),
        'pass': json['pass'] == null ? undefined : json['pass'],
        'occupationalMedicineOneCategory': json['occupationalMedicineOneCategory'] == null ? undefined : json['occupationalMedicineOneCategory'],
        'occupationalMedicineText': json['occupationalMedicineText'] == null ? undefined : json['occupationalMedicineText'],
        'vehicleRestriction': json['vehicleRestriction'] == null ? undefined : json['vehicleRestriction'],
        'personRestriction': json['personRestriction'] == null ? undefined : json['personRestriction'],
        'drivingLicense': json['drivingLicense'] == null ? undefined : json['drivingLicense'],
        'roadTransport': json['roadTransport'] == null ? undefined : json['roadTransport'],
        'active': json['active'] == null ? undefined : json['active'],
        'withoutSign': json['withoutSign'] == null ? undefined : json['withoutSign'],
        'register': json['register'] == null ? undefined : GetRegisterDtoFromJSON(json['register']),
        'twilightVision': json['twilightVision'] == null ? undefined : json['twilightVision'],
        'glareSensitivity': json['glareSensitivity'] == null ? undefined : json['glareSensitivity'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'card': json['card'] == null ? undefined : GetCardDtoFromJSON(json['card']),
        'art39j': json['art39j'] == null ? undefined : json['art39j'],
        'contactWithFood': json['contactWithFood'] == null ? undefined : json['contactWithFood'],
        'dateFrom': json['dateFrom'] == null ? undefined : (new Date(json['dateFrom'])),
        'dateTo': json['dateTo'] == null ? undefined : (new Date(json['dateTo'])),
        'requiresCorrectiveEyewear': json['requiresCorrectiveEyewear'] == null ? undefined : json['requiresCorrectiveEyewear'],
        'statusP1': json['statusP1'],
        'cancelStatusP1': json['cancelStatusP1'],
        'cancellationReason': json['cancellationReason'],
    };
}

export function GetJudgmentDtoToJSON(value?: GetJudgmentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'number': value['number'],
        'lp': value['lp'],
        'exam': GetExamDtoToJSON(value['exam']),
        'nextExamDate': value['nextExamDate'] == null ? undefined : ((value['nextExamDate'] as any).toISOString()),
        'judgmentDate': value['judgmentDate'] == null ? undefined : ((value['judgmentDate'] as any).toISOString()),
        'article': GetArticleDtoToJSON(value['article']),
        'psychologist': GetUserDtoToJSON(value['psychologist']),
        'pass': value['pass'],
        'occupationalMedicineOneCategory': value['occupationalMedicineOneCategory'],
        'occupationalMedicineText': value['occupationalMedicineText'],
        'vehicleRestriction': value['vehicleRestriction'],
        'personRestriction': value['personRestriction'],
        'drivingLicense': value['drivingLicense'],
        'roadTransport': value['roadTransport'],
        'active': value['active'],
        'withoutSign': value['withoutSign'],
        'register': GetRegisterDtoToJSON(value['register']),
        'twilightVision': value['twilightVision'],
        'glareSensitivity': value['glareSensitivity'],
        'comment': value['comment'],
        'card': GetCardDtoToJSON(value['card']),
        'art39j': value['art39j'],
        'contactWithFood': value['contactWithFood'],
        'dateFrom': value['dateFrom'] == null ? undefined : ((value['dateFrom'] as any).toISOString()),
        'dateTo': value['dateTo'] == null ? undefined : ((value['dateTo'] as any).toISOString()),
        'requiresCorrectiveEyewear': value['requiresCorrectiveEyewear'],
        'statusP1': value['statusP1'],
        'cancelStatusP1': value['cancelStatusP1'],
        'cancellationReason': value['cancellationReason'],
    };
}

